import { BaseService } from "core/services";
import { FacilityInventoryCalculationRouteService } from "application/facility-order/services";

class FacilityInventoryCalculationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityInventoryCalculationRouteService());
	}
    
    newFlowCreate(resource) {
        const url = this.routeService.newFlowCreate(resource);
        return this.apiClient.post(url, resource);
    }

    nikoFlowCreate(resource) {
        const url = this.routeService.nikoFlowCreate(resource);
        return this.apiClient.post(url, resource);
    }

	async getExisting(facilityOrderId){
        const url = this.routeService.getExisting(facilityOrderId);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async refresh(id){
        const url = this.routeService.refresh(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async newFlowRefresh(id){
        const url = this.routeService.newFlowRefresh(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async nikoFlowRefresh(id){
        const url = this.routeService.nikoFlowRefresh(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async process(id){
        const url = this.routeService.process(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async newFlowProcess(id){
        const url = this.routeService.newFlowProcess(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async nikoFlowProcess(id){
        const url = this.routeService.nikoFlowProcess(id);
        const response = await this.apiClient.get(url);
        return response.data;
    }
}

export default FacilityInventoryCalculationService;